var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RootContainer',[_vm._t("default"),(_vm.showLogo)?_c('OrbVizLogo',{staticClass:"bg-logo"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }